export const calcDomainScore = (scores, prefix) => {
  const keys = Object.keys(scores).filter(k => k.startsWith(prefix));
  if (keys.length === 0) return 0;
  const sum = keys.reduce((acc, k) => acc + scores[k], 0);
  return Number((sum / keys.length).toFixed(1));
};

export const getTier = (score) => {
  if (score < 1.5) return { level: 1, name: 'Needs Immediate Attention', color: '#DC3545' };
  if (score < 2.5) return { level: 2, name: 'Foundation Building', color: '#FD7E14' };
  if (score < 3.5) return { level: 3, name: 'Developing Alignment', color: '#FFC107' };
  if (score < 4.5) return { level: 4, name: 'Well Aligned', color: '#28A745' };
  return { level: 5, name: 'Industry Leading', color: '#0D6EFD' };
};

export const getOverallScore = (scores) => {
  const printScore = calcDomainScore(scores, 'P');
  const itScore = calcDomainScore(scores, 'I');
  const cyberScore = calcDomainScore(scores, 'C');
  
  const validScores = [printScore, itScore, cyberScore].filter(s => s > 0);
  return validScores.length > 0 
    ? Number((validScores.reduce((a, b) => a + b, 0) / validScores.length).toFixed(1))
    : 0;
};